import { action } from 'mobx';

import { AppManager, Input } from 'core/index';

import { TagsApp } from 'apps/tag/app';

import { CollectionApp } from 'apps/collection/app';
import { CollectionMutation } from 'apps/collection/gql';

export class CollectionFormAppManager extends AppManager {
  static registryName = 'CollectionFormAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.projectId = init.projectId;
    this.projectName = init.projectName;

    this.collectionFormApp = new CollectionApp(this, { tags: new TagsApp() });
    this.collectionFormApp.init();
    this.collectionInput = new Input({
      name: () => this.collectionFormApp.name,
      description: () => this.collectionFormApp.description,
      tags: () =>
        this.collectionFormApp.tags.map(tag => ({
          id: tag.id,
          name: tag.name,
          deleted: tag.deleted,
        })),
    });
  }

  @action SubmitCollection = options => {
    this.mutations.push(CollectionMutation.New(this.collectionInput, options));
  };
}
